// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"20e4413d","488":"28f273b2"}[chunkId] + ".chunk.js";
};